<template>
  <div class="luminance-box" v-show="visible" @click.stop>
    <div class="title">亮度调节</div>
    <div class="slider">
      <div class="label">右侧图像</div>
      <el-slider v-model="luminance.swiper1" @change="onChange($event, 'right')"></el-slider>
      <div class="label">顶部图像</div>
      <el-slider v-model="luminance.swiper2" @change="onChange($event, 'top')"></el-slider>
      <div class="label">左侧图像</div>
      <el-slider v-model="luminance.swiper3" @change="onChange($event, 'left')"></el-slider>
    </div>
  </div>
</template>

<script>
import { updateLuminance } from '@/api/handover-inspection/passing-manage.js'
export default {
  name: "luminance-adjust-dialog",
  props: {
    visible: Boolean,
    luminance: Object,
  },
  created() {
    // todo 查询接口获取亮度
    const obj = {
      swiper1: Number(this.$cache.local.get('swiper1_luminance')) || 30,
      swiper2: Number(this.$cache.local.get('swiper2_luminance')) || 30,
      swiper3: Number(this.$cache.local.get('swiper3_luminance')) || 30
    }
    this.$emit('update:luminance', obj)

  },
  methods: {
    onChange(val, position) {
      const params = {
        isUse: 1,
        optionValue: val,
        optionCode: `brightness_${position}`
      }
      // todo 调接口存
      // updateLuminance(params)
      const obj = {
        right: 'swiper1',
        top: 'swiper2',
        left: 'swiper3',
      }
      this.$cache.local.set(obj[position] + '_luminance', val);
    }
  }
}
</script>

<style scoped lang="scss">
.luminance-box {
  position: absolute;
  width: 200px;
  text-align: left;
  right: -55px;
  top: -220px;
  z-index: 1;
  color: #3C3C3C !important;
  cursor: default;

  .title {
    padding: 10px 15px;
    background-color: #F7F7F7;
  }

  .slider {
    width: 100%;
    padding: 15px;
    background-color: #fff;
  }


}
</style>
